import { render, staticRenderFns } from "./newpage.vue?vue&type=template&id=0e724962&scoped=true&"
import script from "./newpage.vue?vue&type=script&lang=js&"
export * from "./newpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e724962",
  null
  
)

export default component.exports